export default {
  getXeroOrganisation: (state) => state.xeroOrganisation,
};
